var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.Dt=require("ttag");module.exports=$CLJS.Dt;